"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _ButtonGroup = _interopRequireDefault(require("./ButtonGroup"));

var _FourButtonCss = _interopRequireDefault(require("./FourButton.css.js"));

var _radium = _interopRequireDefault(require("radium"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FourButton = function FourButton(_ref) {
  var offer = _ref.offer,
      tracking = _ref.tracking,
      email = _ref.email;
  return /*#__PURE__*/_react.default.createElement("div", {
    style: _FourButtonCss.default.main
  }, /*#__PURE__*/_react.default.createElement("div", {
    style: _FourButtonCss.default.header
  }, "Multiple sponsored results could be available that suit your needs."), /*#__PURE__*/_react.default.createElement("div", {
    style: _FourButtonCss.default.sponsored
  }, "View Sponsored Offers"), /*#__PURE__*/_react.default.createElement(_ButtonGroup.default, {
    buttons: offer.four_button,
    tracking: tracking,
    url: offer.url,
    jump: offer.jump,
    email: email
  }));
};

var _default = (0, _radium.default)(FourButton);

exports.default = _default;

//# sourceMappingURL=FourButton.jsx.map